import React from 'react';

import PropTypes from 'prop-types';

const IconPanel = ({ color = '#4285F4', height = '10em', width = '10em' }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 512 515"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_2869_181)">
            <circle cx="264" cy="252" r="248" fill="white" />
        </g>
        <circle cx="248" cy="248" r="246" stroke={color} strokeWidth="4" />
        <path
            d="M419.227 380.308V178.629L249.634 103L91.5 178.629V380.308H419.227Z"
            fill="#E9ECF5"
        />
        <path
            d="M412.227 380.308V178.629L242.634 103L84.5 178.629V380.308H412.227Z"
            stroke="black"
            strokeWidth="8"
            strokeLinejoin="round"
        />
        <path
            d="M64.5729 190.955L59.1395 181.899C58.5299 180.883 58.9324 179.563 60.0053 179.06L242.663 93.3925C243.194 93.1435 243.808 93.1401 244.341 93.3832L432.047 178.882C433.268 179.439 433.606 181.016 432.719 182.024L424.485 191.381C423.901 192.045 422.949 192.246 422.146 191.876L244.342 109.888C243.808 109.642 243.193 109.643 242.659 109.892L67.1331 191.738C66.2049 192.171 65.0998 191.833 64.5729 190.955Z"
            fill={color}
        />
        <defs>
            <clipPath id="clip0_2869_181">
                <rect
                    width="512"
                    height="512"
                    fill="white"
                    transform="translate(0 3)"
                />
            </clipPath>
        </defs>
    </svg>
);

IconPanel.propTypes = {
    color: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

export default IconPanel;
